<template>
  <div>
    <vue-flip :active-hover="true" width="315px" height="330px">
      <template v-slot:front class="front">
        <div class="proj-bg-img" :style="{backgroundImage: `${bgImgGrad} ,url(${bgImg})`}">
          <div class="proj-gif" :style="{backgroundImage: `url(${gif})`}"></div>
          <div class="titles">
            <span
              class="proj-title"
              :style="{marginBottom: '5px', backgroundImage: bgTitle}"
            >{{title1}}</span>
            <span class="proj-title" :style="{backgroundImage: bgTitle}">{{title2}}</span>
          </div>
        </div>
        <div class="proj-content">
          <ul>
            <li v-for="tech in techs" :key="tech">{{tech}}</li>
          </ul>
        </div>
      </template>
      <template v-slot:back class="back">
        <div class="bg-back" :style="{background: bgBack}">
          <p>{{description}}</p>
          <button @click=" showModal = !showModal">More Info</button>
        </div>
      </template>
    </vue-flip>
    <div class="modal" v-if="showModal" v-scroll-stop>
      <div class="inner-modal">
        <div class="inner-left" :style="{backgroundImage : `url(${vid})`}"></div>
        <div class="inner-right">
          <div
            id="close-btn"
            data-aos="zoom-in"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <i class="fas fa-times" @click="showModal = !showModal"></i>
          </div>
          <div class="proj-title-inner">{{title1 +"\n" + title2}}</div>
          <div class="proj-info-inner">
            <ul class="technologies-inner">
              <li v-for="tech in techs" :key="tech" :style="{marginRight: '15px'}">{{tech}}</li>
            </ul>
            <ul class="features-inner">
              <li
                v-for="feature in features"
                :key="feature"
                :style="{marginRight: '7px'}"
              >{{feature}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueFlip from "vue-flip";

export default {
  name: "ProjectCard",
  data() {
    return {
      showModal: false
    };
  },
  props: [
    "bgImg",
    "gif",
    "bgTitle",
    "bgBack",
    "title1",
    "title2",
    "techs",
    "description",
    "vid",
    "bgImgGrad",
    "features"
  ],
  components: {
    "vue-flip": VueFlip
  },
  methods: {
    stopScroll: function() {
      if (this.showModal === true) {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function() {
          window.scrollTo(x, y);
        };
      } else {
        window.onscroll = function() {};
      }
    }
  }
};
</script>

<style>
</style>